import { Injectable } from '@angular/core';
import {User} from '../classes/User';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const LANG_KEY = 'language';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  signOut(): void {
    window.localStorage.clear();
  }

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user: User): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): User {
    return JSON.parse(localStorage.getItem(USER_KEY));
  }

  public saveLanguage(language: string): void {
    window.localStorage.removeItem(LANG_KEY);
    window.localStorage.setItem(LANG_KEY, language);
  }

  public getLanguage(): string {
    return localStorage.getItem(LANG_KEY);
  }
}
